import { DefaultNowType } from './dateTimeNow'
import {
  getFileNameFromDate,
  getFileNameFromDateV2,
} from './getFileNameFromDate'

export type UploadFilesProcessingProps = {
  partnerId?: string
  assetType?: string
  folder?: string
  filesToBeUploaded?: File[]
  defaultNow?: DefaultNowType
  showRealFileName?: boolean
}

export const uploadFilesProcessing = ({
  defaultNow,
  assetType = '',
  partnerId = '',
  folder = '',
  filesToBeUploaded = [],
  showRealFileName = false,
}: UploadFilesProcessingProps) => {
  const folderPath = `${assetType}/${partnerId}/${folder}`
  const filePathObjects: Record<string, File> = {}
  let path = ''
  const fileNames: string[] = []
  filesToBeUploaded.forEach((file, index) => {
    const dateString = defaultNow ? defaultNow() : ''
    const fileSplit = file.name.split('.')
    const fileType = fileSplit[fileSplit.length - 1]
    const fileName = showRealFileName
      ? getFileNameFromDateV2(dateString, file.name)
      : getFileNameFromDate(dateString, String(index), fileType)
    const finalFileName = `${fileName}`
    fileNames.push(finalFileName)
    const filePath = `${folderPath}/${finalFileName}`
    const uploadPath = filePath.replace(/[\s\u202f]/g, '-')
    filePathObjects[uploadPath] = file
    if (!path) {
      path = uploadPath
    } else {
      path = path.concat(`,${uploadPath}`)
    }
  })
  return { path, filePathObjects }
}
